(function () {
    'use strict';

    angular
        .module('app')
        .factory('WindowTitleService', WindowTitleService);

    WindowTitleService.$inject = ['$window', 'NavigationAidService'];

    function WindowTitleService($window, NavigationAidService) {
        var service = {
            setTitle: setTitle
        };

        return service;

        /**
         * Set the title of the browser window / tab.
         * This will be automatically prepended with 'ChilliDocs'.
         *
         * @param {string} title - Will set the default title if null, undefined or empty.
         */
        function setTitle(title) {
            var windowTitle = 'ChilliDocs';

            if (_.isString(title)) {
                var trimmedTitle = _.trim(title);

                if (trimmedTitle.length > 0) {
                    NavigationAidService.setTitle(trimmedTitle);
                    windowTitle += ' | ' + trimmedTitle;
                }
            }

            // MS Edge refuses to accept a title longer than ~2100 characters, it just keeps using the previously set title
            // So, we truncate to avoid that bug, and because a really really long title is useless anyway.
            windowTitle = windowTitle.substr(0, 128);
            $window.document.title = windowTitle;
        }
    }
})();